import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { track } from '../firebase'

// Fires a page_view on every SPA route change — the SDK only auto-sends one on
// first load. No-ops when analytics is disabled.
export function RouteAnalytics() {
  const location = useLocation()
  useEffect(() => {
    track('page_view', {
      page_path: location.pathname,
      page_location: window.location.href,
      page_title: document.title,
    })
  }, [location.pathname])
  return null
}
